var brandInfoAll={
  bannerInfo:{
    bannerNmae:"清能德创",
    createTime:"2012年",
    area:"中国 北京",
    honor:[
      '国家高新技术企业称号',
      '中关村高新技术企业',
      '恰佩克奖“2016年度优秀伺服品牌”',
      'CMCD2016年度运动控制最具竞争力品牌'
    ]
  },
  subsidiary:[
    {
      name:"北京",
      langname:"北京（总公司）",
      address:"北京市丰台区海鹰路6号院3号楼",
      corporateName:"清能德创电气技术（北京）有限公司"
    },
    {
      name:"上海",
      langname:"上海（子公司）",
      address:"上海市嘉定新城德富路1199号太湖世家环球大厦22层09-11室",
      corporateName:"清能德创电气技术（北京）有限公司"
    },
    {
      name:"河北",
      langname:"河北（子公司）",
      address:"河北省石家庄市高新区太行大街759号连铸连轧车间",
      corporateName:"河北智昆精密传动科技有限公司"
    },
    {
      name:"芜湖",
      langname:"芜湖（子公司）",
      address:"安徽省芜湖市鸠江经济技术开发区灵鹫路与神州路交叉口机器人成果转化中心8栋厂房",
      corporateName:"清能德创电气技术（北京）有限公司"
    },
    {
      name:"济南",
      langname:"济南（办事处）",
      address:"山东省济南市天桥区北关北路6号湖光山色家园4号楼2-203",
      corporateName:"清能德创电气技术（北京）有限公司"
    },
    {
      name:"成都",
      langname:"成都（办事处）",
      address:"四川省成都市郫都区蜀都万达广场14-2-1005号",
      corporateName:"清能德创电气技术（北京）有限公司"
    },
    {
      name:"深圳",
      langname:"深圳（办事处）",
      address:"广东省深圳市宝安大道6099号星港同创汇天玑座208",
      corporateName:"清能德创电气技术（北京）有限公司"
    },
  ],
  advantages:{
    advantages:"/static/brand/zhitong/youshi/left.png",
    advantagesTitle:"/static/brand/zhitong/youshi/top.png",
    info:"产品在效率、空程、温升、噪音等指标上达到了国外主流产品水平。精度保持性、传动精度和刚性等3项指标略优，疲劳寿命指标大幅优于国外主流产品。",
    type:1
  },
  brandAdvantage:{
    titleImg:"/static/brand/qingneng/tedian/left.png",
    oneTitle:"荣获2019中国设计红星奖",
    twoTitle:"多项技术、产品认证",
    list:[
      "国家级高新技术企业",
      "中关村高新技术企业",
      "IOS质量体系认证",
      "ETG一致性认证",
      "产品通过性认证",
      "产品功能安全认证",
      "多项发明专利",
    ]
  },
  certify:[
     
  ],

  otherProductsAdvantages:{
    productsTitle:"/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth:"849px",
    textTitle:"安全可靠的伺服产品丰富机型满足多种需求",
    textList:[
      '采用高性能稀土永久材料，内禀矫顽力高，抗去磁能力强',
      '具有高功率密度，超强过载能力',
      '极低转矩脉动，噪音低，外观精美等特点',
      '三相正弦波磁场设计，动态响应，具有极好的低速平滑性',
      'F级绝缘，IP65防护等级，环境适应性强，使用安全可靠'
    ],
    textImg:"/static/brand/qingneng/youshi/product.png",
    height:"215px",
    list:[
      {
        titleImg:"/static/brand/qingneng/tedian/1.png",
        infoList:[
          '多种通讯技术，为系统提供优异的动态特性和同步精度。',
        ],
        title:"高效"
      },
      {
        titleImg:"/static/brand/qingneng/tedian/2.png",
        infoList:[
          '更高的系统响应，实现更高精度和更高速度的运动控制。',
        ],
        title:"精准" 
      },
      {
        titleImg:"/static/brand/qingneng/tedian/3.png",
        infoList:[
          '基于国际标注的功能安全技术，满足多种场景的安全需求。',
        ],
        title:"安全" 
      },
      {
        titleImg:"/static/brand/qingneng/tedian/4.png",
        infoList:[
          '振动抑制功能，可有效抑制在设备运行过程中产生的噪音和振动。',
        ],
        title:"稳定" 
      },
      {
        titleImg:"/static/brand/qingneng/tedian/5.png",
        infoList:[
          '支持位置控制、速度控制和力矩控制三种方式的在线实时切换。',
        ],
        title:"灵活" 
      },
      {
        titleImg:"/static/brand/qingneng/tedian/6.png",
        infoList:[
          'DriveStarter是清能德创开发的一款免安装伺服调试软件，可轻松的进行参数设定、控制状态监视、安装调试、故障分析等操作。',
        ],
        title:"易用"
      }
    ]


  },
  pindustry:{
      industryTitleImg:"/static/brand/qingneng/hangye/industryTitleImg.png",
      list:[
        {
          bjimg:"/static/brand/qingneng/hangye/1.png",
          title:"工业机器人",
        },
        {
          bjimg:"/static/brand/qingneng/hangye/2.png",
          title:"印刷机械",
        },
        {
          bjimg:"/static/brand/qingneng/hangye/3.png",
          title:"金属加工",
        },
        {
          bjimg:"/static/brand/qingneng/hangye/4.png",
          title:"橡塑机械",
        },
        {
          bjimg:"/static/brand/qingneng/hangye/5.png",
          title:"激光切割",
        },
        {
          bjimg:"/static/brand/qingneng/hangye/6.png",
          title:"纺织机械",
        },
      ]    
    },
  bigimg:"/static/brand/zhitong/bigimg/big.png",
  
  aboutus:
  {
        info:"清能德创电气技术（北京）有限公司成立于2012年，位于北京市丰台区总部基地，是一家国内领先的高新技术企业。清能德创以电力电子技术为核心，融合先进的自动化技术，通过持续创新，为电气传动和能源领域的客户提供高效可靠的产品和解决方案。清能德创以“成为电气传动和能源领域引领技术创新的高科技公司”为己任，通过提供具有先进控制技术的系列产品推动行业发展和产业升级。目前公司推出的高性能伺服驱动等产品，广泛适用于工业机器人、数控机床、纺织机械、包装机械、印刷机械、塑料机械等装备制造行业。",
        video:"https://atomrobot.oss-cn-hangzhou.aliyuncs.com/video/mvb/qingneng.mp4",
        poster:"/static/brand/qingneng/guanyuwomen/video.png",
        aboutTitle:"/static/brand/qingneng/guanyuwomen/top.png",
        aboutTitleWidth:"360px"
  },
  
 
  metaInfo:{
    title:"清能德创_Movibot品牌_伺服驱动器_伺服电机",
    keywords:"伺服驱动器_伺服电机_工业机器人_清能德创",
    description:"清能德创是中国领先的高端伺服驱动器、伺服电机提供商，产品广泛应用于工业机器人、数控机床等高端制造装备领域。MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。",
  }
  


}
export default {
  brandInfoAll
};


// WEBPACK FOOTER //
// ./src/data/brand/3.js